import TransactionList from "@/controllers/transaction/transaction-list.js";
import axios from "axios";
import 'vue-loading-overlay/dist/vue-loading.css';
import tinycolor from "tinycolor2";
import CONFIG from "@/assets/js/config.custom.js";

export default {
    extends: TransactionList,

    data() {
        return {
            isFilterOpen: false,
            transactionCategoryArr: null,
            searchData : [],
            assetTotal: '0',
            investmentTotal: '0',
            CONFIG,
            sortByField: 'ref_transaction_no',
            sortOrder: 'asc',
            isZoomed: false,
            groupModalVisible: false,
            groupModalData: [],
            groupModalLoading: false,
            currentGroupRef: null,
            currentGroupType: null,
        };
    },

    methods: {
        validHexColor(colorCode) {
            const input = String(colorCode ?? "").trim();
            const standardHexRegex = /^#([0-9A-Fa-f]{3}){1,2}$/;
            
            if (!standardHexRegex.test(input)) {
                return ""; 
            }
            const color = tinycolor(input);
            
            return color.isValid() ? color.toHexString() : "";
        },

        getTransactionCategoryList() {
            axios
                .get("/transactionCategory/getTransactionCategoryArray")
                .then((res) => {
                    const categoryList = Array.isArray(res.data?.[0]) ? res.data[0] : [];
                    const categoryOptions = categoryList.map((category) => {
                        const originalText = category?.text ?? "";
                        
                        const truncatedText = originalText.length > 30 
                            ? originalText.substring(0, 30) + "..." 
                            : originalText;
        
                        return {
                            ...category,
                            text: truncatedText,
                            color_code: category?.color_code ?? null,
                        };
                    });
                    this.transactionCategoryArr = categoryOptions;
                })
                .catch((error) => {
                    if (error?.response?.status == 401) {
                        this.$store.commit("logout");
                        window.location.replace("login");
                    }
                });
        },

        getTransactionCategory(categoryId) {
            if (!this.transactionCategoryArr || !this.transactionCategoryArr.length) {
                return { text: "-", color: "" };
            }
            const normalizedCategoryId = Number(categoryId);
            const selectedCategory = this.transactionCategoryArr.find((category) => {
                return Number(category?.id) === normalizedCategoryId;
            });

            return {
                text: selectedCategory?.text || "-",
                color: this.validHexColor(selectedCategory?.color_code),
            };
        },

        reset() {
            this.searchData = [];
            this.isSearch = false;
            this.searchBtnStatus = false;
            this.searchedData = null;
            this.isLoading = true;
            this.getList();
        },

        search(page = 1) {
            this.clearValidationErrors();
            this.searchBtnStatus = true;
            this.isLoading = true;
            this.searchedData = {
                ...this.searchData,
                search_status: this.searchBtnStatus,
            };
            this.isSearch = true;
            this.getList(page);
        },

        getList(page = 1) {
          this.isLoading = true
          const params = {
                campus_id: this.campusId,
                title: this.searchData.title,
                fromAmt: this.searchData.fromAmt,
                toAmt: this.searchData.toAmt,
                payMethod: this.searchData.payMethod,
                start_date: this.searchData.start_date,
                end_date: this.searchData.end_date,
                type: this.searchData.type,
                ref_transaction_no: this.searchData.ref_transaction_no,
                transaction_category_id: this.searchData.transaction_category_id,
                sort_by: this.sortByField,
                sort_order: this.sortOrder,
                search_status: this.isSearch ? true : false,
            };
            axios.get('transaction/list?page=' + page, { params })
            .then(res => {
              if (res.data) {
                this.data = res.data;
                this.incomeTotal = res.data.data.incomeTotal;
                this.expenseTotal = res.data.data.expenseTotal;
                this.assetTotal = res.data.data.assetTotal;
                this.investmentTotal = res.data.data.investmentTotal;
                this.displayAmount = `<p>Total Income - ${this.incomeTotal || 0}</p><br> <p> Total Expense - ${this.expenseTotal || 0} </p><br> <p> Total Asset - ${this.assetTotal || 0} </p><br> <p> Total Investment - ${this.investmentTotal || 0} </p>`;
              }
              this.isLoading = false;
            }).catch(error => {
              if (error.response.status == 401) {
                this.$store.commit('logout');
                window.location.replace('login');
              }
              this.isLoading = false;
            });

        },

        confirmDelete(id, status) {
            if (window.confirm("Are you sure you want to delete?")) {
                this.delete(id, status);
            } else {
                console.log("no");
            }
        },

        excelDownload() {
            this.isLoading = true;
            const params = {
                ...(this.isSearch && this.searchedData ? this.searchedData : {}),
                campus_id: this.campusId
            };
            axios.get('/transaction/excelDownload', {
                params,
                responseType: 'arraybuffer'
            })
                .then(response => {
                    var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                    var fileLink = document.createElement('a');
                    fileLink.href = fileURL;
                    let date = new Date();
                    fileLink.setAttribute('download', `transaction_list_${date.getFullYear()}${(date.getMonth() + 1) < 9 ? 0 : ''}${(date.getMonth() + 1)}${date.getDate() < 9 ? 0 : ''}${date.getDate()}.xlsx`);
                    document.body.appendChild(fileLink);
                    fileLink.click();
                    this.isLoading = false;
                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    }
                    this.isLoading = false;
                });
        },

        delete(id) {
            this.isLoading = true;
            axios.delete(`transaction/delete/${id}`)
                .then(res => {
                    if (res.data)
                        this.getList();
                        this.$notification.success('Transaction Deleted Successfully', {
                            timer: 3,
                            position: "bottomCenter"
                        });
                }).catch(error => {
                    if (error.response.status == 401) {
                        this.$store.commit('logout');
                        window.location.replace('login');
                    } else if (error.response.status == 422) {
                        this.$notification.error(error.response.data.errors?.acd_year_id?.[0], {
                            timer: 3,
                            position: "bottomCenter",
                        });
                    }
                    this.isLoading = false;
                });
        },

        sortBy(field) {
            if (field !== 'ref_transaction_no') {
                return;
            }
            if (this.sortByField === field) {
                this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
            } else {
                this.sortByField = field;
                this.sortOrder = 'asc';
            }
            this.search(this.data.current_page);
        },
        checkZoom() {
            this.isZoomed = window.devicePixelRatio > 1;
        },

        async openGroupModal(refTransactionNo, type, action = 'view', id) {
            this.groupModalLoading = true;
            this.groupModalVisible = false;
            this.currentGroupRef = refTransactionNo;
            this.currentGroupType = type;

            if (!refTransactionNo) {
                this.groupModalLoading = false;
                if (action === 'edit') {
                    this.$router.push({ name: 'transactionEdit', params: { id } });
                } else if (action === 'detail') {
                    this.$router.push({ name: 'transactionDetail', params: { id } });
                } else if (action === 'delete') {
                    this.confirmDelete(id);
                }
                return;
            }

            try {
                const params = { type, campus_id: this.campusId };
                if (this.searchData.title) params.title = this.searchData.title;
                if (this.searchData.payMethod) params.payMethod = this.searchData.payMethod;
                if (this.searchData.start_date) params.start_date = this.searchData.start_date;
                if (this.searchData.end_date) params.end_date = this.searchData.end_date;
                if (this.searchData.fromAmt) params.fromAmt = this.searchData.fromAmt;
                if (this.searchData.toAmt) params.toAmt = this.searchData.toAmt;
                if (this.searchData.transaction_category_id) params.transaction_category_id = this.searchData.transaction_category_id;
                if (this.searchData.invoice_number) params.invoice_number = this.searchData.invoice_number;

                const res = await axios.get(`transaction/group-detail/${refTransactionNo}`, { params });
                const groupData = res.data;

                if (groupData.length === 1) {
                    const child = groupData[0];

                    if (action === 'edit') {
                        this.$router.push({ name: 'transactionEdit', params: { id: child.id } });
                    } else if (action === 'detail') {
                        this.$router.push({ name: 'transactionDetail', params: { id: child.id } });
                    } else if (action === 'delete') {
                        this.confirmDelete(child.id);
                    }
                    return;
                }

                this.groupModalData = groupData;
                this.groupModalVisible = true;
            } catch (error) {
                this.$notification.error('Failed to load group details', { timer: 3, position: "bottomCenter" });
                this.groupModalVisible = false;
            } finally {
                this.groupModalLoading = false;
            }
        },

        closeGroupModal() {
            this.groupModalVisible = false;
            this.groupModalData = [];
            this.currentGroupRef = null;
            this.currentGroupType = null;
        },

        confirmDeleteFromModal(id) {
            this.closeGroupModal();
            this.confirmDelete(id);
        },
    },

    mounted() {
        this.getTransactionCategoryList();
        this.checkZoom();
        window.addEventListener('resize', this.checkZoom);
    },

    beforeDestroy() { 
        window.removeEventListener('resize', this.checkZoom);
    },
}